import { AutogenModelTieredCharge, AutogenRowTieredCharge } from "./autogen/AutogenModelTieredCharge";

export class ModelTieredCharge extends AutogenModelTieredCharge<RowTieredCharge> {
	constructor() {
		super(RowTieredCharge);
	}
}

export class RowTieredCharge extends AutogenRowTieredCharge {
}